module.exports = __webpack_public_path__ + "static/img/9.44d293b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/sp/9.png
// module id = xx+Y
// module chunks = 0